import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02ff5bd9")

_pushScopeId("data-v-02ff5bd9")
const _hoisted_1 = {
  key: 0,
  class: "preview btn mt10 ml16"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "ml8" }, "退出预览", -1)
const _hoisted_3 = {
  key: 1,
  class: "go-back btn mt10 ml8"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "submit" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "ml8" }, "提交", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_b_icon = _resolveComponent("b-icon")
  const _component_ArrowLeftOutlined = _resolveComponent("ArrowLeftOutlined")
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")

  return (_openBlock(), _createBlock("div", {
    class: "header flex flex-row justify-between",
    style: {background: _ctx.view === "preview" ? "#ffffff" : "#ffffff"}
  }, [
    _createVNode("div", {
      class: "back pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
    }, [
      (_ctx.view === "preview")
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_b_icon, { type: "iconchakan" }),
            _hoisted_2
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_ArrowLeftOutlined)
          ]))
    ]),
    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1),
    _createVNode("div", _hoisted_5, [
      (_ctx.view === "submit")
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "btn mt10 mr16 pointer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
          }, [
            _createVNode(_component_CheckCircleOutlined, { class: "sbtn" }),
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
})